import { BuildingDesign } from '@shared/models/design/building-design.model';
import {
  ActivityType,
  ProgramGfaArea,
  programActivityTypes,
} from '@shared/models/design/activities/activity-type.model';
import { designGuards } from './design-typeguards.helpers';
import { Storey } from '@shared/models/design/storey.model';
import { getActivityMixFromDesign } from './activity-mix.helpers';

/** Program areas in GFA, with non-program and unassigned floor area grouped as Other. */
export const getProgramGfaAreas = (
  design:
    | BuildingDesign
    | (Omit<BuildingDesign, 'buildings'> & { storeys: Storey[] })
    | undefined,
  gfa: number,
): ProgramGfaArea[] => {
  if (!Number.isFinite(gfa) || gfa <= 0) return [];
  const normalizedDesign =
    design && !('buildings' in design)
      ? {
          ...design,
          buildings: [
            {
              id: 'program-summary',
              storeys: design.storeys.filter(designGuards.is.storey),
            },
          ],
        }
      : design;
  const mix = normalizedDesign
    ? getActivityMixFromDesign(normalizedDesign)
    : {};
  const programs = programActivityTypes.flatMap((type) => {
    const area = mix[type] ?? 0;
    return Number.isFinite(area) && area > 0 ? [{ type, area }] : [];
  });
  const total = programs.reduce((sum, program) => sum + program.area, 0);
  const scale = total > gfa ? gfa / total : 1;
  const areas: ProgramGfaArea[] = programs.map(({ type, area }) => ({
    type,
    area: area * scale,
  }));
  if (total < gfa) areas.push({ type: ActivityType.Other, area: gfa - total });
  return areas;
};
